/* Explicit route registry shared by Vite and the Next.js adapter. */
import type React from 'react';

export type PageModule = { default: React.ComponentType<any> };
export type RouteModule = { path: string; index?: boolean; load: () => Promise<PageModule> };

export const routeModules: RouteModule[] = [
  { path: 'account/animations/:animation', load: () => import('./account/animations/[animation]') },
  { path: 'account/animations', load: () => import('./account/animations') },
  { path: 'account/content', load: () => import('./account/content') },
  { path: 'account/details', load: () => import('./account/details') },
  { path: 'account/icon-style', load: () => import('./account/icon-style') },
  { path: 'account/name', load: () => import('./account/name') },
  { path: 'account/password', load: () => import('./account/password') },
  { path: 'account/profile', load: () => import('./account/profile') },
  { path: 'account/services', load: () => import('./account/services') },
  { path: 'account/status/levels', load: () => import('./account/status/levels') },
  { path: 'account/status', load: () => import('./account/status') },
  { path: 'account/theme', load: () => import('./account/theme') },
  { path: 'account', load: () => import('./account') },
  { path: 'admin', load: () => import('./admin') },
  { path: 'album/:id', load: () => import('./album/[id]') },
  { path: 'album', index: true, load: () => import('./album/index') },
  { path: 'api-docs', load: () => import('./api-docs') },
  { path: 'help', load: () => import('./help') },
  { path: 'home', load: () => import('./home') },
  { path: '', index: true, load: () => import('./index') },
  { path: 'letters', load: () => import('./letters') },
  { path: 'manage/approvals', load: () => import('./manage/approvals') },
  { path: 'manage/inbox', load: () => import('./manage/inbox') },
  { path: 'manage', index: true, load: () => import('./manage/index') },
  { path: 'manage/logs', load: () => import('./manage/logs') },
  { path: 'manage/sent', load: () => import('./manage/sent') },
  { path: 'manage/settings', load: () => import('./manage/settings') },
  { path: 'manage', load: () => import('./manage') },
  { path: 'meet/milestones', load: () => import('./meet/milestones') },
  { path: 'meet', load: () => import('./meet') },
  { path: 'notifications', load: () => import('./notifications') },
  { path: 'recycle', load: () => import('./recycle') },
  { path: 'search/solution/:id', load: () => import('./search/solution/[id]') },
  { path: 'search', load: () => import('./search') },
];
